
import { Breadcrumbs, BreadcrumbItem } from "@/components/ui/breadcrumb"
import { cn } from "@/lib/utils"

interface PageHeaderProps {
  title: string
  description?: string
  breadcrumbs: BreadcrumbItem[]
  className?: string
}

export const PageHeader = ({ title, description, breadcrumbs, className }: PageHeaderProps) => {
  return (
    <div className={cn("bg-white border-b", className)}>
      <div className="container mx-auto px-4">
        <div className="py-4">
          <Breadcrumbs items={breadcrumbs} />
          <h1 className="text-2xl font-bold text-[#0f2d69] mt-2">{title}</h1>
          {description && (
            <p className="text-sm text-gray-600 mt-1">{description}</p>
          )}
        </div>
      </div>
    </div>
  )
}
